import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { generateClient } from 'aws-amplify/api';
import { getUrl } from 'aws-amplify/storage';
import { listCourses, listExchangeRates } from '../graphql/queries';
import './CoursesPage.css'; 

const CoursesCatalog = () => {
    const navigate = useNavigate();
    const [courses, setCourses] = useState([]);
    const [tasa, setTasa] = useState(1);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const client = generateClient();
        const loadData = async () => {
            try {
                setLoading(true);
                // 1. Cargar Tasa (API KEY)
                const resTasa = await client.graphql({ query: listExchangeRates, authMode: 'apiKey' });
                setTasa(resTasa.data.listExchangeRates.items[0]?.value || 1);

                // 2. Cargar Cursos (API KEY)
                const resCourses = await client.graphql({ query: listCourses, authMode: 'apiKey' });
                const items = resCourses.data.listCourses.items || [];

                // 3. Generar URLs de imágenes
                const coursesWithImages = await Promise.all(items.map(async (course) => {
                    const rawPath = course.thumbnailUrl; 
                    
                    if (rawPath) {
                        try {
                            // Quitamos "public/" si el string lo trae, para evitar duplicados
                            const cleanKey = rawPath.replace(/^public\//, '');
                            
                            // Obtenemos la URL firmada de S3
                            const link = await getUrl({ 
                                path: `public/${cleanKey}`
                            });
                            
                            return { ...course, imageUrl: link.url.toString() };
                        } catch (e) { 
                            return { ...course, imageUrl: "https://gioscarvaci.com/documento-legal2.png" }; 
                        }
                    }
                    // Si no hay ruta en la BD, usamos la imagen por defecto
                    return { ...course, imageUrl: "https://gioscarvaci.com/documento-legal2.png" };
                }));

                setCourses(coursesWithImages);
            } catch (err) { 
                console.error("Error general catalog:", err); 
            } finally {
                setLoading(false);
            }
        };
        loadData();
    }, []);

    if (loading) return <div className="academy-container"><p style={{textAlign:'center', color:'#D4AF37'}}>Cargando Academia...</p></div>;

    return (
        <div className="academy-container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
            <h2 style={{ textAlign: 'center', color: '#001f3f', marginBottom: '10px' }}>ACADEMIA SCARVACI</h2>
            <p style={{textAlign: 'center', marginBottom: '40px', color: '#666'}}>Formación Jurídica y Contable de Alto Nivel</p>
            
            <div className="academy-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '25px' }}>
                {courses.map(course => (
                    <div key={course.id} className="academy-card" onClick={() => navigate(`/course/${course.id}`)} style={{ cursor: 'pointer', border: '1px solid #eee', borderRadius: '12px', overflow: 'hidden', background: '#fff', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}>
                        <div style={{ width: '100%', height: '180px', overflow: 'hidden' }}>
                            <img 
                                src={course.imageUrl} 
                                alt={course.title} 
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                                onError={(e) => { e.target.src = "https://gioscarvaci.com/documento-legal2.png"; }}
                            />
                        </div>
                        <div style={{ padding: '15px' }}>
                            <h3 style={{ fontSize: '1rem', color: '#001f3f', margin: '0 0 10px 0', height: '40px' }}>{course.title}</h3>
                            <p style={{ fontSize: '0.85rem', color: '#777' }}>{course.instructor || "Dr. Giovanni Scarvaci"}</p>
                            
                            <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div>
                                    <div style={{ color: '#b12704', fontWeight: 'bold', fontSize: '1.1rem' }}>${course.priceUSD}</div>
                                    <div style={{ fontSize: '0.8rem', color: '#888' }}>Bs. {(course.priceUSD * tasa).toFixed(2)}</div>
                                </div>
                                <button style={{ padding: '8px 15px', background: '#001f3f', color: 'white', border: 'none', borderRadius: '5px', fontSize: '0.9rem' }}>VER DETALLES</button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CoursesCatalog;